<template>
<div class="comp-card">
  <div class="header">
    <div class="info-panel">
      <div class="sub-name">
        {{display_value?.subEventName || '-'}}
      </div>
      <div class="sub-info">
        {{display_value?.eventName || '-'}} | {{display_value?.time || '-'}}
      </div>
    </div>
    <div class="score">
      {{display_value?.resultOverallScores.split('-').join(' : ')}}
    </div>
  </div>

  <div class="competitor-info">
    <div v-if="display_value && display_value.competitors" class="left-panel">
      <div class="row-item" v-for="(item, index) in display_value.competitors" :key="index">
        <div class="member-info">
          <img class="flag" :src="getCountryIconUrl(item.competitiorOrg)" @error="setDefaultImage"/>
          <img class="icon"
            :src="calPlayerIconUrl(item.players[0].playerWTTId, item.players[0].playerName,headerShot[index][0])"
            @error="(e)=>setDefaultImage(e)"
          />
          <span class="member-name">
            {{item.players[1].playerName?
              (item.players.map(e=>e.player_zh_name?e.player_zh_name:e.playerName).join(' & ') )
              : (item.players[0].player_zh_name?item.players[0].player_zh_name:item.players[0].playerName)}}
          </span>
          <img v-if="item.players[1].playerName"
            class="icon"
            :src="calPlayerIconUrl(item.players[1].playerWTTId, item.players[1].playerName,headerShot[index][1])"
            @error="e=>setDefaultImage(e)"/>
        </div>
        <div class="total-score">
          {{display_value.resultOverallScores.split('-')[index]}}
        </div>
      </div>
    </div>
    <div v-if="scores" class="right-panel">
      <div class="row-item" v-for="(item, index) in scores" :key="index">
        <div class="score-item" :class="element.win?'win':'lose'" v-for="(element, index) in item" :key="index">
          {{element.score}}
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import utils from '../../utils/cardIcon.js'
import defaultImage from '@/assets/icon.png'

export default {
  name: "CompCard",
  data(){
    return {
      headerShot:[[1,1],[1,1]],
      scores: null,
      playerImgs: null,
      display_value: null
    }
  },
  props: {
    "value": {
      type: Object,
      default: null,
    }
  },
  mounted() {
    // if(this.value){
    //   this.get_display_value(this.value)
    // }
  },
  watch: {
    value: {
      handler(value) {
        if(value) {
          let display_value = this.get_display_value(value)
          let score = display_value.competitors.map(item=>item.scores.split(',').map(v=>{return{score:v,win:false}}))
          let n = score[0].length
          for(let i=0;i<n;i++){
            if(parseInt(score[0][i].score)<parseInt(score[1][i].score)){
              score[1][i].win=true
            }else{
              score[0][i].win=true
            }
          }
          this.scores = score
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    get_display_value(value){
      if(value && value.competitors[1].players[0]["player_cn_id_in_db"] === value.selectedPlayer
          || this.value.competitors[1].players[1]["player_cn_id_in_db"] === value.selectedPlayer) {
        let tmp = JSON.parse(JSON.stringify(this.value))
        tmp.competitors.reverse()
        tmp.resultOverallScores = tmp.resultOverallScores.split('-').reverse().join('-')
        this.display_value = tmp
        return tmp
      }
      this.display_value = value
      return value
    },
    calPlayerIconUrl(id,name,type){
      const _name = name.replace(' ', '_')
      const src = 'https://wttsimfiles.blob.core.windows.net/wtt-media/photos/400px/'
      const src1 = `${src}${id}_Headshot_R_${_name}.png`
      const src2 = `${src}${id}_HEADSHOT_R_${_name}.png`
      return type===1?src1:src2
    },
    getCountryIconUrl(country) {
      return utils.getCountryIconUrl(country)
    },
    setDefaultImage(e) {
      // console.log(id,name)
      e.target.src = defaultImage
    }
  }
}
</script>

<style lang="less" scoped>
.comp-card {
  width: 560px;
  height: 160px;
  // width:100%;
  // height:100%;
  background: #FFFFFF;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  margin: auto;

  .header {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(0, 55, 91, 0.28);
    padding: 13px 15px 7px 15px;
    .info-panel {
      font-family: 'Lantinghei SC';
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: -0.015em;
      color: #00375B;
      text-align: left;
      .sub-name {
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 2px;
      }
      .sub-info {
        font-size: 14px;
      }
    }
    .score {
      font-family: 'DIN Alternate';
      font-style: normal;
      font-weight: 700;
      font-size: 40px;
      line-height: 24px;
      /* or 60% */

      text-align: right;
      letter-spacing: -0.015em;

      color: #0072BE;
    }
  }

  .competitor-info {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    .left-panel{
      width: 51.4%;
      border-right: 1px solid #0072BE;
    }
    .right-panel {
      width: 48.6%;
      padding-left: 10px;
    }
    .row-item {
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      .member-info {
        text-overflow: ellipsis;
        height: 24px;
        overflow: hidden;
        white-space: nowrap;
        .flag {
          width: 30px;
          height: 20px;
          margin: 2px 0;
          vertical-align: top;
          border: rgb(0 0 0 / 25%) 1px solid;
        }
        .icon {
          width:30px;
          height:30px;
          object-fit:contain;
          border-radius: 50%;
          margin: 0 6px;
        }
        .member-name {
          font-family: 'Lantinghei SC';
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          letter-spacing: -0.015em;
          color: #00375B;
        }
      }
      .total-score {
        font-family: 'DIN Alternate';
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 24px;
        padding: 0 14px;
        text-align: center;
        letter-spacing: -0.015em;

        color: #0072BE;
      }
      .score-item {
        font-family: 'DIN Alternate';
        font-style: normal;
        font-weight:400;
        font-size: 24px;
        line-height: 24px;
        text-align: center;
        letter-spacing: -0.015em;
        width: 30px;
        &.win {
          color: #0072BE;
        }
        &.lose {
          color: #8E8E8E;
        }
      }
    }

    .row-item+.row-item{
      margin-top:8px;
    }
  }
}

</style>
